import _extends from "@babel/runtime/helpers/extends";
import { ursaColors } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { Icon } from "../../icon/Icon";
import ProgressBarSvg from "./ProgressBarSvg";

// Override the default sizing CSS custom properties with those for the ProgressBarIcon, but
// only if there are values.
const cssCustomProperties = {
  "--smar--ursa-icons--height": "var(--smar--ursa-icons--progress-bar--height, unset)",
  "--smar--ursa-icons--width": "var(--smar--ursa-icons--progress-bar--width, unset)"
};
export const ProgressBarIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color = ursaColors.blue400,
    emptyFillColor = ursaColors.neutral00,
    size,
    value,
    ...rest
  } = _ref;
  const finalSize = {
    width: size?.width ? Number(size.width) : 71,
    height: size?.height ? Number(size.height) : 20
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    color: color,
    size: finalSize,
    ref: ref,
    cssCustomProperties: cssCustomProperties
  }, rest), /*#__PURE__*/React.createElement(ProgressBarSvg, {
    value: value,
    size: finalSize,
    emptyFillColor: emptyFillColor
  }));
});
ProgressBarIcon.displayName = "ProgressBarIcon";
//# sourceMappingURL=ProgressBarIcon.js.map